import { useGetDispatchPlaces, useGetDispatchPlaceSummary } from '@/features/dispatch-places/dispatch-places.queries';
import { useGetFinanceSummary } from '@/features/finances/finances.queries';
import { useGetOrders } from '@/features/orders/orders.queries';

/**
 * Aggregates all data needed by the Home dashboard.
 * Each data domain is fetched independently so a single failure doesn't block
 * the rest of the page.
 */
export const useHomePage = () => {
  const placesQuery = useGetDispatchPlaces();
  const summaryQuery = useGetDispatchPlaceSummary();
  const ordersQuery = useGetOrders();
  const financeSummaryQuery = useGetFinanceSummary();

  const places = placesQuery.data?.items ?? [];

  const ordersAtPlace = (ordersQuery.data?.items ?? []).filter(
    (order) => order.status === 'at_dispatch_place',
  );

  return {
    place_summary: summaryQuery.data,
    places,
    orders_at_place: ordersAtPlace,
    orders_at_place_count: ordersAtPlace.length,
    pending_payouts: financeSummaryQuery.data?.pending_payouts ?? 0,
    finance_currency: financeSummaryQuery.data?.currency ?? 'MXN',
    is_loading:
      placesQuery.isLoading ||
      summaryQuery.isLoading ||
      ordersQuery.isLoading ||
      financeSummaryQuery.isLoading,
    is_fetching:
      placesQuery.isFetching ||
      summaryQuery.isFetching ||
      ordersQuery.isFetching ||
      financeSummaryQuery.isFetching,
  };
};
